import { render, staticRenderFns } from "./Medico.vue?vue&type=template&id=c9d19e54"
import script from "./Medico.vue?vue&type=script&lang=js"
export * from "./Medico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports